// Module
var code = "<abx-work-order-list class=\"flat\" abx-building=\"vm.building\" abx-models=\"vm.workOrders\" · abx-fetch=\"vm.fetchWorkOrders(skip, limit)\" abx-fetch-all=\"vm.fetchAllWorkOrders(limit)\" abx-fetch-limit=\"100\" abx-status=\"vm.status\" abx-create-options=\"vm.createOptions\"> </abx-work-order-list> ";
// Exports
module.exports = code;